/** Minimal classname joiner for the local @archieai/ui 2.8.x shims. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
